import Button from 'components/Button'
import React from 'react'
import moment from "moment"

export const COLUMNS = [
  {
    Header: 'Date',
    accessor: `formData[dateOfApplication]`,
    Cell: (props: any) => {
      return moment(props.value).format('DD-MM-YYYY');
    }
  },
  {
    Header: 'Staff Name',
    accessor: `formData[RequstedByName]`,
  },
  {
    Header: 'Staff Dept',
    accessor: `formData[RequstedByDepartment]`,
  },
  {
    Header: 'Patient Id',
    accessor: `formData[raiseRequestPatientId]`,
  },
  {
    Header: 'Patient Name',
    accessor: `formData[raiseRequestPatientName]`,
  },
  {
    Header: 'Center',
    accessor: 'centerName',
  },
  {
    Header: 'Documents',
    accessor: 'view',
    Cell: (props: any) => {
      return (
        <Button
          text="View"
          id="renew-request"
          disabled={props?.row?.original?.status === 'REJECTED' || props?.row?.original?.status === 'PENDING' ? true : false}
        ></Button>
      )
    }
  },
  {
    Header: '',
    accessor: 'Edit',
    Cell: (props: any) => {
      const today = moment().format('MM-DD-YYYY')
      const dateOfApplication = moment(props?.row?.original?.formData?.dateOfApplication).format('MM-DD-YYYY')
      const date1: any = new Date(today);
      const date2: any = new Date(dateOfApplication);
      var oneDay = 24 * 60 * 60 * 1000;
      var diffDays = Math.abs((date1?.getTime() - date2?.getTime()) / (oneDay));
      // console.log(diffDays)
      return (
        <Button
          text="Renew Request"
          id="renew-request"
          disabled={diffDays < 7 ? true : false}
        ></Button>
      )
    }
  },
  // Cell: (props: any) => {
  //   return props.value == "Active" ? (
  //     <span style={{ color: "green" }}>Active</span>
  //   ) : (
  //     <span style={{ color: "red" }}> Inactive</span>
  //   )
  // }
]
